import React from "react";
import ReactDOM from "react-dom/client";
import { I18nProvider } from "@/contexts/I18nContext";
import reportWebVitals from "./reportWebVitals";
import { WebSocketProvider } from "@/components/WebSocketProvider";
import { FileUploadProvider } from "./contexts/FileUploadContext";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("ai-customer-service") as HTMLElement
);

root.render(
  <React.StrictMode>
    <I18nProvider>
      <WebSocketProvider>
        <FileUploadProvider>
          <App />
        </FileUploadProvider>
      </WebSocketProvider>
    </I18nProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
